(function () {
  'use strict';

  /* ─────────────────────────── Carousel data ─────────────────────────── */
  const SLIDES_DESKTOP = [
    { src: 'https://cdn.shopify.com/videos/c/o/v/8c54e4b5d63c439caf03ca03fd77f73e.mp4', poster: 'https://cdn.shopify.com/s/files/1/0938/1897/8590/files/gym-desktop-thumbnail.png?v=1778040135' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/8d46d33b72924fbb844fcf2d4b0c7500.mp4', poster: 'https://cdn.shopify.com/s/files/1/0938/1897/8590/files/running-thumbnail-desktop.png?v=1777535577' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/4bc6ac7ebf4b421ebf0c451084452b61.mp4', poster: 'https://cdn.shopify.com/s/files/1/0938/1897/8590/files/travellifestyle-thumbnail-desktop.png?v=1777535578' }
  ];
  const SLIDES_MOBILE = [
    { src: 'https://cdn.shopify.com/videos/c/o/v/26566b0559e14f88a016f61a0558df3c.mp4', poster: 'https://cdn.shopify.com/s/files/1/0938/1897/8590/files/gym-mobile-thumbnail.png?v=1778040134' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/04d1fd7104da49d7b4def599d192a5b1.mp4', poster: 'https://cdn.shopify.com/s/files/1/0938/1897/8590/files/running-thumbnail-mobile.png?v=1777535577' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/a52dd49ba0954d40be11bb0fa50b3457.mp4', poster: 'https://cdn.shopify.com/s/files/1/0938/1897/8590/files/travellifestyle-thumbnail-mobile.png?v=1777535577' }
  ];
  const OPTIONS = { mobileBreakpoint: 768, autoplayMs: 0, swipeThreshold: 50, loop: true, advanceOnEnd: true };

  /* Run a callback after the page has painted and the browser is idle.
     Used so the placeholder image (LCP) and the hero content always render
     BEFORE we spend any bandwidth on video. */
  function afterPaintIdle(cb) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(cb, { timeout: 1500 });
        } else {
          setTimeout(cb, 200);
        }
      });
    });
  }

  function restoreSectionBg() {
    const section = window.__reploHcDeferredSection;
    if (!section) return;
    const orig = section.dataset.reploHcOrigInlineBg || '';
    if (orig) section.style.backgroundImage = orig;
    else section.style.removeProperty('background-image');
    delete section.dataset.reploHcOrigInlineBg;
    window.__reploHcDeferredSection = null;
  }

  /* ─── Move ONLY the hydrated Replo testimonial carousel into the slot, drop the SSR ghost ─── */
  function relocateTestimonial() {
    const slot = document.getElementById('heroTestimonialsSlot');
    if (!slot) return;

    // the interactive instance marks its inner track with data-is-hydrated="true"
    const isHydrated = function (node) {
      return node.querySelector('[data-is-hydrated="true"]') !== null;
    };

    const run = function () {
      const nodes = document.querySelectorAll('[data-testimonial-carousel]');
      if (!nodes.length) return;

      // find the live (hydrated) carousel
      let live = null;
      nodes.forEach(function (n) { if (!live && isHydrated(n)) live = n; });

      // hydration hasn't happened yet — do NOT move the pre-hydration node
      // (moving it is what breaks hydration and spawns the duplicate)
      if (!live) return;

      // move the live one into the slot
      if (!slot.contains(live)) {
        slot.appendChild(live);
        window.dispatchEvent(new Event('resize')); // let Replo recompute widths
      }

      // remove every other (non-hydrated SSR ghost) copy
      nodes.forEach(function (n) {
        if (n !== live && !isHydrated(n) && n.parentNode) {
          n.parentNode.removeChild(n);
        }
      });
    };

    run();

    // keep watching until hydration completes, then settle
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  /* ─────────────────────────── Hero carousel ─────────────────────────── */
  function init() {
    const root = document.getElementById('reploHeroCarousel');
    if (!root || root.dataset.reploHcInit === 'true') return;
    root.dataset.reploHcInit = 'true';

    const track       = root.querySelector('#reploHcTrack');
    const dotsWrap    = root.querySelector('#reploHcDots');
    const prevBtn     = root.querySelector('#reploHcPrev');
    const nextBtn     = root.querySelector('#reploHcNext');
    const placeholder = root.querySelector('#reploHcPlaceholder');

    let slides = [], videos = [], dots = [];
    let currentIndex = 0;
    let isTouching = false, touchStartX = 0, touchDeltaX = 0;
    let autoplayTimer = null, resizeRaf = null, isWrapping = false;
    let placeholderHidden = false;
    let mql = null;

    function hidePlaceholderWhenReady(v) {
      if (placeholderHidden || !placeholder || !v) return;
      const hide = function () {
        if (placeholderHidden) return;
        placeholderHidden = true;
        placeholder.classList.add('replo-hc__placeholder--hidden');
        setTimeout(function () {
          if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
        }, 250);
      };
      if (v.readyState >= 2) { hide(); return; }
      v.addEventListener('loadeddata', hide, { once: true });
      v.addEventListener('playing',    hide, { once: true });
    }

    function getActiveData() {
      const isMobile = window.matchMedia('(max-width: ' + OPTIONS.mobileBreakpoint + 'px)').matches;
      return isMobile ? SLIDES_MOBILE : SLIDES_DESKTOP;
    }
    function hasClonesNow() { return OPTIONS.loop && slides.length > 1; }
    function logicalToPhysical(i) { return hasClonesNow() ? i + 1 : i; }
    function getMetrics() {
      const cs = getComputedStyle(root);
      const peek = parseFloat(cs.getPropertyValue('--replo-hc-peek')) || 0;
      const gap  = parseFloat(cs.getPropertyValue('--replo-hc-gap'))  || 0;
      const W = root.offsetWidth || 1;
      return { peek: peek, gap: gap, stride: W - 2 * peek - gap, W: W };
    }
    function getTransformX(i) {
      if (slides.length <= 1) return 0;
      const m = getMetrics();
      return (m.peek + m.gap) - logicalToPhysical(i) * m.stride;
    }
    function activeVideo() { return videos[logicalToPhysical(currentIndex)]; }

    function makeSlide(item, ariaLabel, isClone) {
      const slide = document.createElement('div');
      slide.className = 'replo-hc__slide' + (isClone ? ' replo-hc__slide--clone' : '');
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'slide');
      slide.setAttribute('aria-label', ariaLabel);
      if (isClone) slide.setAttribute('aria-hidden', 'true');
      if (item.poster) slide.style.backgroundImage = 'url("' + item.poster + '")';

      const video = document.createElement('video');
      video.className = 'replo-hc__video';
      video.muted = true; video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.preload = 'none';
      if (item.poster) video.poster = item.poster;
      video.dataset.src = item.src;

      if (OPTIONS.advanceOnEnd && !isClone) {
        video.addEventListener('ended', function () {
          if (isWrapping) return;
          if (video !== activeVideo()) return;
          next();
        });
      }
      slide.appendChild(video);
      return { slide: slide, video: video };
    }

    function buildSlides(deferVideo) {
      videos.forEach(function (v) { v.pause(); v.removeAttribute('src'); v.load(); });
      track.innerHTML = ''; dotsWrap.innerHTML = '';
      slides = []; videos = []; dots = [];
      currentIndex = 0; isWrapping = false;

      const data = getActiveData();
      if (!data || data.length === 0) { root.style.display = 'none'; return; }
      root.style.display = '';

      const single = data.length <= 1;
      root.classList.toggle('replo-hc--single', single);
      const useClones = OPTIONS.loop && data.length > 1;

      if (useClones) {
        const c = makeSlide(data[data.length - 1], 'Slide preview', true);
        track.appendChild(c.slide); videos.push(c.video);
      }
      data.forEach(function (item, i) {
        const s = makeSlide(item, 'Slide ' + (i + 1) + ' of ' + data.length, false);
        track.appendChild(s.slide); slides.push(s.slide); videos.push(s.video);
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'replo-hc__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i, true); });
        dotsWrap.appendChild(dot); dots.push(dot);
      });
      if (useClones) {
        const c = makeSlide(data[0], 'Slide preview', true);
        track.appendChild(c.slide); videos.push(c.video);
      }

      prevBtn.style.display = single ? 'none' : '';
      nextBtn.style.display = single ? 'none' : '';
      dotsWrap.style.display = single ? 'none' : '';

      updateUI(false);

      if (deferVideo) {
        /* placeholder + content paint first; video downloads only once idle */
        afterPaintIdle(function () { activateVideoAt(0); });
      } else {
        activateVideoAt(0);
      }
    }

    function updateAriaAndDots() {
      dots.forEach(function (d, i) {
        const active = i === currentIndex;
        d.classList.toggle('replo-hc__dot--active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i === currentIndex ? 'false' : 'true');
      });
    }

    function updateUI(animate) {
      if (animate === false) track.classList.add('replo-hc__track--no-transition');
      track.style.transform = 'translate3d(' + getTransformX(currentIndex) + 'px, 0, 0)';
      if (animate === false) { void track.offsetWidth; track.classList.remove('replo-hc__track--no-transition'); }
      updateAriaAndDots();
    }

    function tryPlay(v) {
      if (!v || document.hidden) return;
      const p = v.play();
      if (p && p.catch) p.catch(function () {
        const retry = function () {
          v.removeEventListener('loadeddata', retry);
          if (!document.hidden) { const p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }
        };
        v.addEventListener('loadeddata', retry, { once: true });
      });
    }
    function ensureSrc(v, preload) { if (v && !v.src) { v.src = v.dataset.src; v.preload = preload || 'auto'; v.load(); } }
    function detachSrc(v) { if (v && v.src) { v.removeAttribute('src'); v.load(); } }

    function activateVideoAt(logicalIndex) {
      const physicalActive = logicalToPhysical(logicalIndex);
      videos.forEach(function (v, physI) {
        if (physI === physicalActive) {
          v.setAttribute('autoplay', ''); v.autoplay = true;
          ensureSrc(v, 'auto');
          try { v.currentTime = 0; } catch (e) {}
          tryPlay(v);
          hidePlaceholderWhenReady(v);
        } else {
          v.removeAttribute('autoplay'); v.autoplay = false;
          v.pause(); detachSrc(v);
        }
      });
    }

    function goTo(targetLogical, userInitiated) {
      const len = slides.length;
      if (len === 0 || isWrapping) return;
      let normalized = OPTIONS.loop ? ((targetLogical % len) + len) % len : Math.max(0, Math.min(len - 1, targetLogical));
      if (normalized === currentIndex) return;
      const useClones = hasClonesNow();
      const isWrapForward  = useClones && currentIndex === len - 1 && normalized === 0;
      const isWrapBackward = useClones && currentIndex === 0       && normalized === len - 1;
      if (isWrapForward || isWrapBackward) wrapAnimate(normalized, isWrapForward ? 'forward' : 'backward');
      else { currentIndex = normalized; updateUI(true); activateVideoAt(currentIndex); }
      if (userInitiated) restartAutoplay();
    }

    function wrapAnimate(targetLogical, direction) {
      isWrapping = true;
      const m = getMetrics(); const len = slides.length;
      currentIndex = targetLogical; updateAriaAndDots();
      const targetPhys = targetLogical + 1;
      const cloneIdx = direction === 'forward' ? len + 1 : 0;
      ensureSrc(videos[targetPhys], 'auto');
      ensureSrc(videos[cloneIdx], 'auto');
      track.style.transform = 'translate3d(' + ((m.peek + m.gap) - cloneIdx * m.stride) + 'px, 0, 0)';
      let done = false;
      function finish() {
        if (done) return; done = true;
        track.removeEventListener('transitionend', onEnd);
        track.classList.add('replo-hc__track--no-transition');
        track.style.transform = 'translate3d(' + getTransformX(currentIndex) + 'px, 0, 0)';
        void track.offsetWidth;
        track.classList.remove('replo-hc__track--no-transition');
        activateVideoAt(currentIndex); isWrapping = false;
      }
      function onEnd(e) { if (e.propertyName === 'transform') finish(); }
      track.addEventListener('transitionend', onEnd);
      setTimeout(finish, 1500);
    }

    function next() { goTo(currentIndex + 1, true); }
    function prev() { goTo(currentIndex - 1, true); }

    function startAutoplay() {
      if (!OPTIONS.autoplayMs || autoplayTimer) return;
      autoplayTimer = setInterval(function () { goTo(currentIndex + 1, false); }, OPTIONS.autoplayMs);
    }
    function stopAutoplay() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }
    function restartAutoplay() { if (OPTIONS.autoplayMs) { stopAutoplay(); startAutoplay(); } }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { videos.forEach(function (v) { v.pause(); }); stopAutoplay(); }
      else { tryPlay(activeVideo()); startAutoplay(); }
    });

    window.addEventListener('resize', function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () { if (!isWrapping) updateUI(false); });
    });

    function onTouchStart(e) {
      if (isWrapping) return;
      isTouching = true; touchStartX = e.touches[0].clientX; touchDeltaX = 0;
      track.classList.add('replo-hc__track--no-transition');
    }
    function onTouchMove(e) {
      if (!isTouching) return;
      touchDeltaX = e.touches[0].clientX - touchStartX;
      track.style.transform = 'translate3d(' + (getTransformX(currentIndex) + touchDeltaX) + 'px, 0, 0)';
    }
    function onTouchEnd() {
      if (!isTouching) return;
      isTouching = false;
      track.classList.remove('replo-hc__track--no-transition');
      if (Math.abs(touchDeltaX) > OPTIONS.swipeThreshold) { if (touchDeltaX < 0) next(); else prev(); }
      else updateUI(true);
      touchDeltaX = 0;
    }
    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove',  onTouchMove,  { passive: true });
    track.addEventListener('touchend',   onTouchEnd);
    track.addEventListener('touchcancel', onTouchEnd);

    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);
    root.tabIndex = 0;
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); prev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
    });

    function onMqlChange() { buildSlides(); startAutoplay(); }
    mql = window.matchMedia('(max-width: ' + OPTIONS.mobileBreakpoint + 'px)');
    if (mql.addEventListener) mql.addEventListener('change', onMqlChange);
    else if (mql.addListener) mql.addListener(onMqlChange);

    /* initial build defers the video so the LCP poster + content paint first */
    buildSlides(true);
    startAutoplay();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.dispatchEvent(new CustomEvent('hero-painted'));
        restoreSectionBg();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); relocateTestimonial(); });
  } else {
    init();
    relocateTestimonial();
  }
})();
